import { MutableRefObject, useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import classNames from 'classnames';

type CurrencyFormType = {
  isDisabled?: boolean;
  decimalLimit?: number;
  defaultValue?: number;
  changeValueHandler: Function;
  prefix?: string;
  suffix?: string;
  inputRef?: MutableRefObject<any>;
  height?: string;
  width?: string;
  hasBlur?: boolean;
  required?: boolean;
};

const CurrencyInput = ({
  defaultValue,
  changeValueHandler,
  isDisabled = false,
  decimalLimit = 0,
  prefix,
  suffix,
  inputRef,
  height,
  width = 'w-full',
  hasBlur = false,
  required = false,
}: CurrencyFormType) => {
  const [currentValue, setCurrentValue] = useState<number | string>('');
  useEffect(() => {
    setCurrentValue(defaultValue ?? '');
    return () => setCurrentValue(defaultValue ?? '');
  }, [defaultValue]);
  const borderError = 'border-red-500 focus:border-red-500 dark:border-red-600 dark:focus:border-red-500 focus:ring-red-500 dark:focus:ring-red-500';
  return (
    <div className={`currency-input flex flex-col ${width}`}>
      <div className={`${width} flex justify-center items-center`}>
        <div className="hidden this-value-for-export-csv">{defaultValue}</div>
        <NumericFormat
          getInputRef={inputRef}
          value={defaultValue ?? ''}
          onValueChange={values => {
            setCurrentValue(values.floatValue ? values.floatValue : values.formattedValue);
          }}
          onKeyUp={(e: any) => {
            if (e.key === 'Enter') {
              const newValue = Number(e.target.value.replace(/[$,]/g, ''));
              if (newValue !== Number(defaultValue || 0)) {
                changeValueHandler(newValue);
              }
            }
          }}
          onBlur={e => {
            if (hasBlur) {
              const newValue = Number(e.target.value.replace(/[$,]/g, ''));
              if (newValue !== Number(defaultValue || 0)) {
                changeValueHandler(newValue, true);
              }
            }
          }}
          disabled={isDisabled}
          maxLength={15}
          thousandSeparator=","
          decimalScale={decimalLimit}
          fixedDecimalScale={true}
          prefix={prefix}
          suffix={suffix}
          required={required}
          className={classNames(`${width} ${height} text-sm text-gray-900 border ${required && ((Number(currentValue?.toString()?.replace(/[$,]/g, '')) === 0) || isNaN(Number(currentValue?.toString()?.replace(/[$,]/g, '')))) && borderError} border-gray-200 px-1.5 py-2 rounded`)}
        />
      </div>
    </div>
  );
};

export default CurrencyInput;
